import { isMobileGameDevice } from '../hooks/useMobileGameViewport';

export async function lockMobileLandscape() {
  if (!isMobileGameDevice()) return;
  try {
    const orientation = window.screen.orientation as ScreenOrientation & { lock?: (mode: string) => Promise<void> };
    await orientation?.lock?.('landscape');
  } catch { /* Some browsers do not permit orientation locking. */ }
}

export async function enterMobileFullscreen() {
  if (!isMobileGameDevice()) return;
  // The Android Activity already owns fullscreen; browser fullscreen can change
  // the layout viewport a second time and crop the game on some WebViews.
  if (/PKNiN\//i.test(navigator.userAgent)) return;
  try {
    if (!document.fullscreenElement && document.documentElement.requestFullscreen) {
      await document.documentElement.requestFullscreen({ navigationUI: 'hide' });
    }
  } catch { /* Orientation may still be available without fullscreen. */ }
  await lockMobileLandscape();
}
